<template lang="html">
  <div id="d-page-template-1">

    <!-- <section class="search-section-s1">
      <b-form @submit="onSubmit">
        <b-form-group class="form-group-s1">
          <b-form-input
          v-model="formSearch.keywords"
          type="text"
          placeholder="Buscar..."
          required
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" class="btn-search">
          <i class="far fa-search"></i>
        </b-button>
      </b-form>
    </section> -->

    <section class="short-info-section-s1" v-if="!loading">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Vacaciones</h2>
        </div>

        <div class="col-sm-6 col-buttons">
          <a class="btn btn-s1 bg-red" @click="openModal()">Solicitar vacaciones</a>
        </div>
      </div>

      <div class="box-vacations-info">
        <div class="col-sm-3 col-info">
          <h5 class="title"><br>Antiguedad:<br></h5>
          <h4 class="number">{{vacations.antiquity}}</h4>
        </div>

        <div class="col-sm-2 col-info">
          <h5 class="title">Años<br>laborados:</h5>
          <h4 class="number">{{vacations.worked_years}}</h4>
        </div>

        <div class="col-sm-2 col-info">
          <h5 class="title">Días de<br>periodo:</h5>
          <h4 class="number">{{vacations.period_days}}</h4>
        </div>

        <div class="col-sm-2 col-info">
          <h5 class="title">Dias<br>tomados:</h5>
          <h4 class="number">{{vacations.days_taken}}</h4>
        </div>
        <div class="col-sm-3 col-info">
          <h5 class="title">Dias<br>pendientes:</h5>
          <h4 class="number">{{vacations.days_enjoy}}</h4>
        </div>
      </div>
    </section>

    <section class="requests-section" v-if="!loading">
      <h3 class="s-title">Solicitudes</h3>

      <div class="box-results">
        <b-card no-body>
          <b-tabs card>

            <!-- Pendientes -->
            <b-tab title="Pendientes" active>
              <b-card-text>
                <div class="no-gutters post-template-s4" v-for="(v, vInx) in pendings" :key="'vInx-'+vInx">
                  <div class="col-12 col-title">
                    <h5>Periodo de vacaciones:</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Comienza</h6>
                    <h5>{{v.start_date}}</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Termina</h6>
                    <h5>{{v.end_date}}</h5>
                  </div>

                  <div class="col-sm col-time col-days">
                    <h6>Día(s)</h6>
                    <h5>{{v.days}}</h5>
                  </div>

                  <div class="col-md col-approval">
                    <h5 class="pending">Pendiente de aprobación</h5>
                  </div>
                </div>
                <div class="no-gutters post-template-s4" v-if="pendings.length == 0">
                  <div class="col-12 col-title">
                    <h5 style="text-align: center;">No existen registros de datos</h5>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <!--  -->

            <!-- Autorizados -->
            <b-tab title="Autorizadas - Historico">
              <b-card-text>
                <div class="no-gutters post-template-s4" v-for="(v, vInx) in authorized" :key="'vInx-'+vInx">
                  <div class="col-12 col-title">
                    <h5>Periodo de vacaciones:</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Comienza</h6>
                    <h5>{{v.start_date}}</h5>
                  </div>

                  <div class="col-sm col-time">
                    <h6>Termina</h6>
                    <h5>{{v.end_date}}</h5>
                  </div>

                  <div class="col-sm col-time col-days">
                    <h6>Día(s)</h6>
                    <h5>{{v.days}}</h5>
                  </div>

                  <div class="col-md col-approval">
                    <h5 class="">Autorizadas</h5>
                  </div>
                </div>
                <div class="no-gutters post-template-s4" v-if="authorized.length == 0">
                  <div class="col-12 col-title">
                    <h5 style="text-align: center;">No existen registros de datos</h5>
                  </div>
                </div>
              </b-card-text>
            </b-tab>
            <!--  -->

          </b-tabs>
        </b-card>

        
      </div>
    </section>
    <section class="requests-section" v-else>
        <div class="box-results" style="padding-top: 150px;text-align: center;">
              <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>          
        </div>
    </section>  
    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
          <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
          <div v-html="modal.msg"></div>
          
        </sweet-modal>

    <b-modal modal-class="modal-request-s1" ref="modal-request" title="Solicitar Vacaciones" size="lg" centered hide-footer>
      <div class="text-center box-content">
        <h4 class="title-1">Días restantes disponibles</h4>
        <h3 class="mt-2 num">{{vacations.days_enjoy}}</h3>
        <h5 class="mt-2 note" v-if="vacations.days_enjoy == 1">*Solo tienes un día disponibles</h5>
      </div>

      <b-form @submit="onSubmitForm">
        <b-form-group class="form-group-s1 f-g-timepicker"
          label="Comienza">
          <b-form-datepicker v-model="formModal.start_date" :min="minDate" :date-disabled-fn="dateDisabled" :date-format-options="dateFormOpts" v-bind="datepickerOpts"  placeholder="dd/mm/aaaa" required></b-form-datepicker>
        </b-form-group>

        <b-form-group class="form-group-s1 f-g-timepicker"
          label="Termina">
          <b-form-datepicker v-model="formModal.end_date" :min="minDate" :date-disabled-fn="dateDisabled" :date-format-options="dateFormOpts" v-bind="datepickerOpts"  placeholder="dd/mm/aaaa" required></b-form-datepicker>
        </b-form-group>

        <b-form-group class="form-group-s1 f-g-timepicker"
          label="Fecha de presentación a laborar">
          <b-form-datepicker v-model="formModal.presentation_date" :min="minDate" :date-disabled-fn="dateDisabled" :date-format-options="dateFormOpts" v-bind="datepickerOpts"  placeholder="dd/mm/aaaa" required></b-form-datepicker>
        </b-form-group>

        <b-form-group class="form-group-s1"
          label="Comentarios">
          <b-form-textarea
            v-model="formModal.comments"
            placeholder="Ingresa los comentarios"
            rows="4"
            max-rows="4"
          ></b-form-textarea>
        </b-form-group>

        <div class="box-signature" v-if="showSignaturePad" style="text-align: center;">
            <VueSignaturePad class="signature-pad" ref="signaturePad" style="border:1px solid" />

            <div class="box-buttons">
              <a class="btn btn-primary" style="background-color: black; border-color: black;" @click="resetSignature">Intentar de nuevo</a>
       
             
            </div>
        </div>


        <b-button type="submit" class="btn-s1 bg-red btn-lg mt-2 w-100">Solicitar</b-button>
        <p>Para las áreas comerciales y de post venta se cancelan las vacaciones en el último trimestre del año. *Pueden ser autorizadas por el gerente de área siempre y cuando no ponga en riesgo la operación.</p>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formSearch: {
        keywords: null
      },

      formModal: {
        comienza: null,
        termina: null,
        comentarios: null,
        signatureUrl:null,
      },

      // == Variables para datepicker y timepicker ==
      minDate: null,
      dateFormOpts: { year: 'numeric', month: 'numeric', day: 'numeric' },
      datepickerOpts: {
        labelPrevYear: 'Año anterior',
        labelPrevMonth: 'Mes anterior',
        labelCurrentMonth: 'Mes actual',
        labelNextMonth: 'Mes siguiente',
        labelNextYear: 'Año siguiente',
        labelToday: 'Hoy',
        labelSelected: 'Fecha Seleccionada',
        labelNoDateSelected: 'No seleccionado',
        labelCalendar: 'Calendario',
        labelHelp: 'Use las teclas de movimiento para navegar'
      },
      
      vacations:{},
      pendings:[],
      authorized:[],
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
      loading:false,
      showSignaturePad:false,
      
      // == ==
    }
  },

  methods: {
      dateDisabled(ymd, date) {
        // Disable weekends (Sunday = `0`, Saturday = `6`)
        const weekday = date.getDay();
        const day = date.getDate();
        // Return `true` if the date should be disabled
        return weekday === 0 || weekday === 6
      },

      onSubmit(event) {
        event.preventDefault();
      },

      onSubmitForm(event) {
        event.preventDefault();

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        this.formModal.signatureUrl = data;

          this.modal.icon = "";
          this.modal.msg = 'Cargando...';
          this.modal.block = true;
          this.$refs.modal.open();
          axios.post(tools.url("/api/vacations"),this.formModal).then((response)=>{
              this.$refs['modal-request'].hide();
              this.modal.block = false;
              this.modal.icon = 'success';
              this.modal.msg = 'Información guardada correctamente';
              this.getRows();
          }).catch((error)=>{
              this.modal.block = false;
              this.modal.icon = 'error';
              this.modal.msg = error.response.data.msg;
          });
      },
      getRows(){
        this.loading = true;
        axios.get(tools.url("/api/vacations")).then((response)=>{
            this.vacations = response.data.vacations;
            this.pendings = response.data.pendings;
            this.authorized = response.data.authorized;
            this.loading = false;
        }).catch(()=>{
          this.loading = false;
        });
      },
      resetSignature() {
        this.$refs.signaturePad.clearSignature();
      },

      openModal(){
        this.$refs['modal-request'].show();
        setTimeout(()=>{ this.showSignaturePad = true; }, 500);
      }
      

  },

  beforeMount(){
    const now = new Date();
    this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  },

  mounted() {
      this.getRows();
  },
}
</script>
